import { GetTradeDetailsResp } from '#/unified-rfqs/repositories/grfq-types';
import { Resp } from '@paradigm/api/src/fetch-api';

export function sideView(tradeResp: Resp<GetTradeDetailsResp> | null) {
  if (tradeResp?.ok !== true) return null;
  return tradeResp.data.action ?? null;
}
